import * as React from 'react';

import { FIELD_PATHS } from '@funnels/constants';

import { StringDisplay, TextAreaField } from '../../Fields';
import { TextAreaFieldProps } from '../../Fields/TextAreaField';
import { EditableViewProps, StringReadOnlyViewProps } from '../types';

interface AssetCommentsEditableViewProps extends EditableViewProps, Omit<TextAreaFieldProps, 'name'> {
  label?: string;
  incomeIndex: number;
}

export const AssetCommentsEditableView = (props: AssetCommentsEditableViewProps) => {
  const { label = 'Comments', incomeIndex, isOptional, ...rest } = props;
  return (
    <TextAreaField {...rest} isOptional={isOptional} label={label} name={FIELD_PATHS.INCOME_COMMENTS(incomeIndex)} />
  );
};

export const AssetCommentsReadOnlyView = (props: StringReadOnlyViewProps) => (
  <StringDisplay title={'Comments'} value={props.value} />
);
